import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

export const initializeDayjs = () => {
    dayjs.extend(customParseFormat)
}
